import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'expand-collapse-actions-link',
    template: `
		<div class="expand-collapse" style="top: {{ upDownAdjust }};">
			<span (click)="onExpandCollapse(true)">expand all</span>
			&nbsp;&nbsp;
			<span (click)="onExpandCollapse(false)">collapse all</span>
		</div>
	`,
    styleUrls: ['./expand-collapse-actions-link.component.less'],
    standalone: true,
})
export class ExpandCollapseActionsLinkComponent {
	/**
	 * Adjust upwards: use negative pixels ie('-10px')
	 * Adjust downwards: use regular pixels ie('10px')
	 */
	@Input() upDownAdjust = '0';
	@Output() expandCollapseEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

	onExpandCollapse(expand: boolean) {
		this.expandCollapseEmitter.emit(expand);
	}
}
